














































import { FormItem, Input, InputNumber, Radio, RadioGroup } from 'element-ui'
import { Vue, Prop, Component, Ref } from 'vue-property-decorator'

import CustomMoneyInput from '@/components/CustomMoneyInput.vue'

import Booking from '@/models/booking'
import PaymentAmountOptions from '@/models/payment-amount-options'

@Component({
  components: {
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [InputNumber.name]: InputNumber,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    CustomMoneyInput,
  },
})
export default class CustomPaymentOption extends Vue {
  @Prop() booking!: Booking
  @Prop() amountToPay!: number
  @Prop(String) paymentAmountOption!: PaymentAmountOptions
  @Ref() readonly customMoneyInputRef!: CustomMoneyInput

  mounted() {
    this.handlePaymentAmountOptionUpdate(this.paymentAmountOption)
  }

  get amountOptions() {
    return PaymentAmountOptions
  }

  handleCustomAmountInputFocus(
    event: FocusEvent & { target: HTMLInputElement },
  ) {
    setTimeout(() => event.target.select(), 50)
    this.handlePaymentAmountOptionUpdate(PaymentAmountOptions.Custom)
  }

  handlePaymentAmountOptionUpdate(paymentOption: PaymentAmountOptions) {
    this.$emit('on-payment-amount-option-update', paymentOption)

    if (paymentOption === PaymentAmountOptions.Custom) {
      this.handleInput(this.customMoneyInputRef.value)
    }
  }

  handleInput(amount: string): void {
    this.$emit('on-amount-to-pay-update', amount)
  }

  handleChange(amount: string): void {
    this.$emit('on-amount-to-pay-update', amount)
  }
}
